import type { FormInstance }  from 'antd';
import { Select }             from 'antd';
import { Spin }               from 'antd';
import React                  from 'react';
import { observer }           from 'mobx-react';
import { Col }                from 'antd';
import Row                    from 'components/App/Row';
import { Form }               from 'antd';
import { ApiCollection }      from 'collections/ApiCollection';
import { AppFormComponent }   from 'components/App/AppForm';
import Input                  from 'components/App/IntlInput';
import LayoutTypeModel        from 'models/LayoutTypeModel';
import StandLayoutModel       from 'models/StandLayoutModel';
import handleFormError        from 'utils/handleFormError';
import FormItem               from 'components/App/FormItem';
import StandModel             from 'models/StandModel';
import { messageSuccessIntl } from 'utils/messageIntl';

interface StandLayoutFormProps {
  model: StandLayoutModel;
  onSuccess: (model: StandLayoutModel) => void;
  stand: StandModel;
}

@observer
class StandLayoutForm extends AppFormComponent<StandLayoutFormProps> {
  public collLayoutType = new ApiCollection(LayoutTypeModel);

  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state: {
    loading: boolean;
  } = {
      loading: true,
    };

  public async componentDidMount() {
    await this.setInitialValues();

    await this.collLayoutType.list();

    this.setState({
      loading: false,
    });
  };

  public async componentDidUpdate(prevProps: StandLayoutFormProps) {
    if (prevProps.model.id !== this.props.model.id) {
      await this.setInitialValues();
    }
  };

  public render() {
    return (
      <Spin spinning={this.state.loading}>
        <Form
          className="antd-form-custom-style"
          ref={this.formRef}
        >
          <Row>
            <Col span={24}>
              <FormItem label="Type d'aménagement" name="layoutType">
                <Select
                  placeholder="Sélectionner un type d'aménagement"
                  style={{ width: '100%' }}
                >
                  {this.collLayoutType.map((layoutType: LayoutTypeModel) => (
                    <Select.Option key={layoutType.id} value={layoutType.get('@id')}>
                      {layoutType.label}
                    </Select.Option>
                  ))}
                </Select>
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="Description" name="description">
                <Input placeholder="Description" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Spin>
    );
  };

  public setInitialValues = async () => {
    const { model } = this.props;

    this.formRef.current?.setFieldsValue({
      description: model.description,
      layoutType: model.layoutTypeIri,
    });
  };

  public submit = async () => {
    const { model, onSuccess, stand, } = this.props;

    const values = await this.formRef.current?.validateFields();

    try {
      await model.patch({
        ...values,
        stand: stand.get('@id'),
      });

      messageSuccessIntl("Enregistrement réussi !");

      if (onSuccess) {
        onSuccess(model);
      }

      this.formRef.current?.resetFields();
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };
}

export default StandLayoutForm;
